import React, { useState } from 'react';
import { Button, Modal, Form, ButtonGroup,Card, Row, Col} from 'react-bootstrap';
import { BiEdit, BiSearch, BiSort } from 'react-icons/bi';
import { AiOutlinePlusCircle } from 'react-icons/ai';  
import './/foodlist.css'

const ProductCard = ({ product }) => {
    return (
      <Card className="foodlistcard shadow-lg mb-5 bg-white rounded">
        <Card.Body>
          <Card.Title>{product.name}</Card.Title>
          <Card.Text>
            Location: {product.location}<br/>
            Expiration Date: {product.expirationDate}
          </Card.Text>
        </Card.Body>
      </Card>
    );
  };

  const getProducts = () => {
    // const productsList = JSON.parse(localStorage.getItem('products'));
    // const currUser = localStorage.getItem('username');

    return JSON.parse(localStorage.getItem('products'));
  };
  
  const FoodListPage = () => {
    const [show, setShow] = useState(false);
    const [products, setProducts] = useState(getProducts() || []);  // Load the products from the local storage
    const [customReminder, setCustomReminder] = useState(false);

    // Function to filter out expired products
    const filterExpiredProducts = (products) => {
    const today = new Date();
    return products.filter(product => new Date(product.expirationDate) >= today);
  };

  // Filter out expired products
    const nonExpiredProducts = filterExpiredProducts(products);
  
    const handleClose = () => {
        setShow(false);
        setCustomReminder(false);  // Add this line
      };
    const handleShow = () => setShow(true);
  
    const handleSubmit = (event) => {
        event.preventDefault();
        const newProduct = {
          name: event.target.elements.productName.value,
          location: event.target.elements.location.value,
          expirationDate: event.target.elements.expirationDate.value,
          reminder: event.target.elements.reminder.value === 'Custom date' ? event.target.elements.customReminderDate.value : event.target.elements.reminder.value
        };
        
        const updatedProducts = [...products, newProduct];
        setProducts(updatedProducts);
        // localStorage.setItem('products', JSON.stringify(updatedProducts));  
        // setShow(false);
        // setShow(false);
        // setProducts([...products, newProduct]);
        localStorage.setItem('products', JSON.stringify(updatedProducts));
        setShow(false);
        setCustomReminder(false);
      };
    const handleReminderChange = (event) => {
        setCustomReminder(event.target.value === 'Custom date');
    };
    
    
    return  (
        <div className="container d-flex flex-column justify-content-between" style={{ height: 'calc(100vh - 56px)' }}>
      {nonExpiredProducts.length > 0 ? (
        <Row className="mt-5">
          {nonExpiredProducts.map((product, index) => (
            <Col md={4} key={index}>
              <ProductCard product={product} />
            </Col>
          ))}
        </Row>
          ) : (
            <div className="text-center my-auto">
              <AiOutlinePlusCircle className="add-icon" size={96} />
              <p>You will see your food list here.. but the list is empty. Tap the "Write" button to add the food</p>
            </div>
          )}
      
          <div className="d-flex justify-content-around align-items-center mb-3">
            <ButtonGroup aria-label="Basic example">
              <Button variant="primary" onClick={handleShow} className="hover-effect">
                <BiEdit /> Write
              </Button>
              <Button variant="primary" className="hover-effect">
                <BiSearch /> Scan
              </Button>
              <Button variant="primary" className="hover-effect">
                <BiSort /> Sort
              </Button>
            </ButtonGroup>
          </div>
      
          <Modal show={show} onHide={handleClose} centered>  
            <Modal.Header closeButton>
              <Modal.Title>Add a product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control type="text" name="productName" placeholder="Enter product name" />
                </Form.Group>
      
                <Form.Group className="mb-3">
                  <Form.Label>Location</Form.Label>
                  <Form.Select name="location">
                    <option>Fridge</option>
                    <option>Freezer</option>
                    <option>Pantry</option>
                  </Form.Select>
                </Form.Group>
      
                <Form.Group className="mb-3">
                  <Form.Label>Expiration Date</Form.Label>
                  <Form.Control type="date" name="expirationDate" />
                </Form.Group>

                <Form.Group className="mb-3">
                <Form.Label>Set Reminder</Form.Label>
                <Form.Select name="reminder" onChange={handleReminderChange}>
                    <option>3 days before</option>
                    <option>5 days before</option>
                    <option>Custom date</option>
                </Form.Select>
                {customReminder && (
                    <Form.Control type="date" name="customReminderDate" className="mt-3" />
                )}
                </Form.Group>
      
                <Button variant="primary" type="submit">
                  Save Changes
                </Button>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      );
  }
  
  export default FoodListPage;